import { ToggleGroup, ToggleItem } from 'components/ToggleGroup'
import { RequestedProviderSelection } from 'jobs/creation/DraftChange'
import { observer } from 'mobx-react'
import * as React from 'react'
import { Id } from 'types/definitions'
import PreviousProviderSelectionViewModel from '../../../PreviousProviderSelectionViewModel'

interface PreviousProviderSelectorProps {
  vm: PreviousProviderSelectionViewModel
}

/**
 * The PreviousProviderSelector
 */
export default observer(function PreviousProviderSelector({
  vm,
}: PreviousProviderSelectorProps) {
  const select = React.useCallback(
    (member: RequestedProviderSelection) => vm.select(member),
    [vm],
  )
  const selectFirstAvailable = React.useCallback(
    () => select(RequestedProviderSelection.firstAvailable),
    [select],
  )
  return (
    <ToggleGroup
      stretch
      focus$={vm.step.becomeActive$}
      onFocus={vm.step.onBecameActive}
    >
      <ToggleItem
        toggled={vm.selected === RequestedProviderSelection.firstAvailable}
        onChange={selectFirstAvailable}
        dataTest="draft-editor-provider-selection-first-available"
      >
        First Available
      </ToggleItem>
      {vm.availableProviders.map((provider) => (
        <ToggleItem
          title={provider.displayName}
          key={Id.assert(provider.user.publicId)}
          toggled={vm.selected === provider}
          onChange={() => select(provider)}
          disabled={vm.disabled}
          dataTest={`draft-editor-provider-selection-provider-${provider.displayName}`}
        >
          {provider.displayName}
        </ToggleItem>
      ))}
    </ToggleGroup>
  )
})
